<template>
    <div class="c-info">
        <LayoutContent>
            <div class="c-info-box">
                <div class="c-list-box">
                    <div class="list-item is-content">
                        <div class="cd-title-box">
                            <h5 class="text-space is-title">GVoice SDK V{{ updateInstructions.version }}</h5>
                            <p class="text-space is-detail">更新说明于{{ updateInstructions.date }}发布</p>
                        </div>
                        <ul class="cd-listitem-box">
                            <!-- <li class="list-item">{{ $t("main:[优化] 网络传输优化，抗丢包能力提升一倍;") }}</li>
                            <li class="list-item">{{ $t("main:[更新] ostream句柄泄露crash fix;") }}</li>
                            <li class="list-item">{{ $t("main:[更新] 支持声纹增强（默认关闭）") }}</li> -->
                            <li class="list-item" v-for="(item, index) in updateInstructions.desc" :key="index">{{ item }}</li>
                        </ul>
                    </div>
                    <div class="list-item">
                        <Button href="https://docs.qq.com/doc/DSVhyVXFJYm14ck1a" target="_blank" type="ghost" size="small" style="width: 180px" :adaptation="true"
                            ><span
                                >{{ $t("main:更多") }}<span class="c-m-hide">{{ $t("main:更新历史") }}</span></span
                            >
                            <i class="gvfont gvfont-youjiantou"></i
                        ></Button>
                    </div>
                </div>
            </div>
        </LayoutContent>
    </div>
</template>

<script>
import Button from "@/components/UI/Button.vue";
import LayoutContent from "@/components/UI/LayoutContent.vue";
import { store } from "@ice/stark-data";

export default {
    name: "Info",
    components: { LayoutContent, Button },
    data() {
        return {
            updateInstructions: store.get("UPDATE_CONFIG") || {},
        };
    },
};
</script>

<style scoped lang="less">
.c-info {
    display: flex;
    align-items: center;
    min-height: 200px;
    padding: 16px 24px;
    background: #252a9c url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/sdk/bg-info.png) no-repeat right center;
    background-size: auto 100%;
    position: relative;
    overflow: hidden;
    &::after {
        content: "";
        width: 100%;
        height: 214%;
        position: absolute;
        top: -2%;
        left: 0;
        background: radial-gradient(#1b66c1, rgba(255, 255, 255, 0) 67%, rgba(255, 255, 255, 0) 100%);
    }
}
.cd-title-box {
    .text-space {
        color: #fff;
        & + .text-space {
            margin-top: 8px;
        }
        &.is-title {
            font-size: 28px;
            font-weight: normal;
        }
        &.is-detail {
            font-size: 14px;
            color: #bbbbbe;
        }
    }
}
.cd-listitem-box {
    .list-item {
        font-size: 14px;
        color: #fff;
        opacity: 0.8;
        & + .list-item {
            margin-top: 4px;
        }
    }
}
.c-list-box {
    display: flex;
    position: relative;
    z-index: 10;
    & > .list-item {
        &.is-content {
            flex: 1;
            display: flex;
        }
        & + .list-item {
            margin-left: 24px;
        }
    }
}
.cd-title-box {
    min-width: 372px;
    & + .cd-listitem-box {
        margin-left: 48px;
    }
}
@media only screen and (max-width: 1200px) {
    .c-list-box {
        .c-button {
            width: auto !important;
        }
    }
    .cd-title-box {
        min-width: 0;
        & + .cd-listitem-box {
            margin-left: 24px;
        }
    }
}
@media only screen and (max-width: 768px) {
    .c-list-box {
        & > .list-item {
            &.is-content {
                flex-direction: column;
            }
        }
    }
    .cd-title-box {
        & + .cd-listitem-box {
            margin-left: 0;
            margin-top: 24px;
        }
    }
}
@media only screen and (max-width: 480px) {
    .cd-title-box {
        .text-space {
            &.is-title {
                font-size: 24px;
            }
        }
    }
    .c-m-hide {
        display: none;
    }
}
</style>
